import axios from "axios";
import { getToken } from "./config";
import { toast } from "react-toastify";
import { getCookie } from "./getcookie";

const isHttpsOnly = process.env.REACT_APP_HTTPS_ONLY === "true";

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { "Content-Type": "application/json" },
    withCredentials: isHttpsOnly,
});

// Add token to all requests
axiosInstance.interceptors.request.use(
    (config) => {
        if (!isHttpsOnly) {
           /*  const token = getToken();
            if (token) { */
                config.headers.Authorization = getCookie("mawalog");
            /* } */
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Handle token expiration globally
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            // Show session expired toast
            toast.error("Session expired, please log in again");

            // Clear localStorage
            localStorage.removeItem("token");
            localStorage.removeItem("user");

           handleUnauthorized();
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;

const handleUnauthorized = () => {
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
 
  // Clear tokens/cookies
  document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  document.cookie = "mawalog=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
 
  const currentURL = window.location.href;
  const redirectData = {
    redirectPath: currentURL,
    app: "accounts",
    ts: Date.now(),
  };
 
  // Safe tab-specific storage for post-login redirect
  window.name = JSON.stringify(redirectData);
 window.location.href = `${accountsUrl}`;
};











// Old method

// axiosInstance.js
// import axios from "axios";

// const axiosInstance = axios.create({
//     baseURL: process.env.REACT_APP_API_URL,
//     headers: { "Content-Type": "application/json" },
// });

// axiosInstance.interceptors.request.use(
//     (config) => {
//         const token = localStorage.getItem("token");
//         if (token) {
//             config.headers.Authorization = `Bearer ${token}`;
//         }
//         return config;
//     },
//     (error) => Promise.reject(error)
// );

// export default axiosInstance;

